import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchFulfilled,
  handleFetchPending,
  handleFetchRejected,
} from "redux/helpers/fetching"
import { fetchManager } from "redux/features/manager/managerThunk"

const managerAdapter = createEntityAdapter()
export const initialState = managerAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const managerSlice = createSlice({
  name: "manager",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchManager.pending, (state) => handleFetchPending(state))
      .addCase(fetchManager.rejected, (state) => handleFetchRejected(state))
      .addCase(fetchManager.fulfilled, (state, { payload }) => {
        managerAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
  },
})

export const { selectById: selectManagerById } = managerAdapter.getSelectors(
  (state: RootState) => state.features.manager,
)
export const selectFetchStatus = (state: RootState) =>
  state.features.manager.fetchStatus

export default managerSlice.reducer
